import { createStore } from 'redux';
import agentReducer from './reducers';  // Importing the default exported reducer

// Create the Redux store with the imported reducer
const store = createStore(agentReducer);

// Export the store as the default export
export default store;

